/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Add, HeadModul, ModulContainer, TxtContainer2 } from '../table/TableStyles';
import { AudienceReportContainer } from './GalleryStyles';
import { DarkButton } from 'components/style/Global';
import { API, Amplify } from 'aws-amplify';
import { IoMdClose, IoMdOpen } from 'react-icons/io';
import { getPreSignedUrl, getStoredQuery } from 'graphql/queries';
import {
  DeleteStoredQueryMutation,
  GetPreSignedUrlQuery,
  GetStoredQueryQuery,
  Placeholder,
  S3Method,
  StoreQueriesMutation,
  StoreQueriesV2Mutation,
} from 'API';
import { useCampaignContext } from 'context/CampaignContext';
import APIContext from 'context/APIContext';
import { PublishContext } from 'context/PublishContext';
import { v4 as uuidv4 } from 'uuid';
import { deleteStoredQuery, storeQueries, storeQueriesV2 } from 'graphql/mutations';
import ClientStatementsContext from 'context/ClientStatementsContext';
import UploadIcon from 'assets/uploadIcon';
import { FileUploader } from 'react-drag-drop-files';
import { useVideoParams } from 'customHooks/useParameters';
const {
  REACT_APP_IDENTITY_POOL_ID,
  REACT_APP_AWS_REGION,
  REACT_APP_USER_POOL_ID,
  REACT_APP_USER_FILES_S3_BUCKET,
  REACT_APP_USER_WEB_CLIENT_ID,
} = process.env;

type Props = {
  componentID: string;
  visible?: boolean;
  setUploadComponents?: any;
  uploadComponents?: any;
  oldComponentID?: string | null;
};

Amplify.configure({
  Auth: {
    identityPoolId: REACT_APP_IDENTITY_POOL_ID,
    region: REACT_APP_AWS_REGION,
    userPoolId: REACT_APP_USER_POOL_ID,
    userPoolWebClientId: REACT_APP_USER_WEB_CLIENT_ID,
  },
  Storage: {
    AWSS3: {
      bucket: REACT_APP_USER_FILES_S3_BUCKET,
      region: REACT_APP_AWS_REGION,
    },
  },
});

const ARContainer = (props: Props) => {
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [caption, setCaption] = useState<any>();
  const { statements } = useContext(ClientStatementsContext);
  const { activeCampaign, dashType, activeSubCampaign, canDoInsourceAndOnInsourcePortal } = useCampaignContext();
  const { getEnvironment } = useContext(APIContext);
  const { updateOLArray, publishedData, placeholderResetToken } = useContext(PublishContext);
  const lastPlaceholderRef = useRef<any>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [contentType, setContentType] = useState<any>();
  const [isImage, setIsImage] = useState<boolean>(false);
  const [visible, setVisible] = useState(false);
  const [uploadStat, setUploadStat] = useState<any>();
  const [videoSource] = useVideoParams();

  useEffect(() => {
    props.visible && setVisible(props.visible);
  }, [props.visible]);

  useEffect(() => {
    if (publishedData.length > 0 && activeCampaign?.authorized === false && !canDoInsourceAndOnInsourcePortal) {
      publishedData.forEach((element: Placeholder) => {
        const elementPosition =
          (dashType === 'TV' && videoSource !== 'BVOD') || dashType === 'RADIO'
            ? element.position?.split('_')[0]
            : element.position;
        if (
          props.oldComponentID &&
          props.oldComponentID !== null &&
          elementPosition === props.oldComponentID &&
          element.metrics
        ) {
          getPresigned(element.outputlocation, element.metrics[0]?.chartType);
          setCaption(element.title);
        } else if (elementPosition === props.componentID && element.metrics) {
          getPresigned(element.outputlocation, element.metrics[0]?.chartType);
          setCaption(element.title);
        }
      });
    }
  }, [publishedData]);

  useEffect(() => {
    if (publishedData.length > 0 && activeCampaign?.authorized === false && !canDoInsourceAndOnInsourcePortal) {
      const found =
        props.oldComponentID && props.oldComponentID !== null
          ? publishedData.find((element: any) => element.position?.split('_')[0] === props.oldComponentID)
          : publishedData.find((element: any) => element.position?.split('_')[0] === props.componentID);
      found !== undefined ? setVisible(true) : setVisible(false);
    }
  }, [publishedData]);

  useEffect(() => {
    if (
      (activeCampaign?.authorized === true || (!activeCampaign?.authorized && canDoInsourceAndOnInsourcePortal)) &&
      statements?.Queries?.READ
    ) {
      /* setTimeout(() => {
                fetchStoredQueriesID();
            }, 4000); */
      if (props.visible) {
        fetchStoredQueriesID();
      }
    }
  }, [activeCampaign, statements]);

  async function fetchStoredQueriesID() {
    try {
      const response = (await API.graphql({
        query: getStoredQuery,
        variables: {
          campaign_id: activeCampaign?.campaignId?.toString(),
          position:
            activeSubCampaign?.name && !props.componentID.startsWith('BVOD')
              ? props.oldComponentID && props.oldComponentID !== null
                ? `${props.oldComponentID}_${activeSubCampaign.subcampaignId}`
                : `${props.componentID}_${activeSubCampaign.subcampaignId}`
              : props.oldComponentID && props.oldComponentID !== null
                ? props.oldComponentID
                : props.componentID,
          // position: props.oldComponentID && props.oldComponentID !== null ? props.oldComponentID : props.componentID,
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: GetStoredQueryQuery };
      const responseData = response.data.getStoredQuery;

      if (responseData) {
        const capt = responseData?.title;
        setCaption(capt);
        const name = responseData?.query_id;
        // fileName se više ne koristi kao state, već direktno proslijeđujemo name

        const cType = responseData?.metrics ? responseData?.metrics[0]?.chartType : '';
        setContentType(cType);
        getPresigned(name, cType);
        // setVisible(true);

        const placeholdersObject = {
          position:
            activeSubCampaign?.name && !props.componentID.startsWith('BVOD')
              ? `${props.componentID}_${activeSubCampaign.subcampaignId}`
              : props.componentID,
          outputlocation: name,
          outputlocationTotal: 'noTotal',
          metrics: {
            chartType: cType,
            metric: 'image',
            axis: 1,
          },
          title: capt,
        };
        lastPlaceholderRef.current = placeholdersObject;
        updateOLArray(placeholdersObject);
      }
    } catch (e) {
      console.log(`ERROR WAS THIS: ${e}`, e);
    }
  }

  useEffect(() => {
    if (lastPlaceholderRef.current) {
      updateOLArray(lastPlaceholderRef.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placeholderResetToken]);

  const putPresigned = async (autoSave = false) => {
    try {
      const fileN = `${uuidv4()}_${selectedImage.name}`;
      const preSignedURL = (await API.graphql({
        query: getPreSignedUrl,
        variables: {
          ClientMethod: S3Method.put_object,
          Client: {
            code: activeCampaign?.ClientCode,
            country: activeCampaign?.ClientCountry,
          },
          Environment: getEnvironment,
          FileName: fileN,
          ContentType: selectedImage.type,
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: GetPreSignedUrlQuery };
      const url = preSignedURL.data.getPreSignedUrl?.url;
      await addToS3(url);

      // Ako je autoSave true, automatski pozovi saveQuery s pravilnim parametrima
      if (autoSave) {
        // Koristimo caption ili prazan string ako nije postavljen
        const titleToSave = caption || '';
        await saveQueryWithParams(fileN, titleToSave);
      }

      setShowUploadModal(false);
    } catch (e) {
      console.error('Error during upload process:', e);
      // alert('Greška prilikom uploada datoteke. Molimo pokušajte ponovo.');
    }
  };

  async function addToS3(url: any) {
    try {
      await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': `${selectedImage.type}`,
        },
        body: selectedImage,
      });
    } catch (e) {
      console.log('Error adding to S3,', e);
    }
  }

  const getPresigned = async (name: any, cType: any) => {
    try {
      const preSignedURL = (await API.graphql({
        query: getPreSignedUrl,
        variables: {
          ClientMethod: S3Method.get_object,
          Client: {
            code: activeCampaign?.ClientCode,
            country: activeCampaign?.ClientCountry,
          },
          Environment: getEnvironment,
          FileName: name,
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: GetPreSignedUrlQuery };
      const url = preSignedURL.data.getPreSignedUrl?.url;

      getFromS3(url, name, cType);
    } catch (e) {
      console.log('Error getting presigned URL', e);
    }
    setShowUploadModal(false);
  };

  async function getFromS3(url: any, name: string, cType: string) {
    try {
      const response = fetch(url, {
        method: 'GET',
      });
      setIsImage(true);
      const test = createFile((await response).url, name, cType);
      test.then((data) => {
        setSelectedImage(data);
      });
    } catch (err) {
      console.log({ err });
    }
  }

  async function createFile(url: any, name: string, cType: string) {
    if (typeof window === 'undefined') return; // make sure we are in the browser
    const response = await fetch(url);
    const data = await response.blob();
    const metadata = {
      type: cType || 'image/png',
    };
    return new File([data], name, metadata);
  }

  async function removeFromS3() {
    setSelectedImage(null);
    setIsImage(false);

    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const deleteStoredQ = (await API.graphql({
        query: deleteStoredQuery,
        variables: {
          campaign_id: activeCampaign?.campaignId?.toString(),
          Environment: getEnvironment,
          placeholder: activeSubCampaign?.name
            ? `${props.componentID}_${activeSubCampaign.subcampaignId}`
            : props.componentID,
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: DeleteStoredQueryMutation };
      /*             unpublishCampaign()
                              window.location.reload(); */
    } catch (e) {
      console.log('ERROR  DELETING QUERY', e);
    }
  }

  async function saveQueryWithParams(queryId: string, queryTitle: string) {
    try {
      const placeholdersObject = {
        position:
          activeSubCampaign?.name && !props.componentID.startsWith('BVOD')
            ? `${props.componentID}_${activeSubCampaign.subcampaignId}`
            : props.componentID,
        outputlocation: queryId,
        outputlocationTotal: 'noTotal',
        metrics: [
          {
            chartType: selectedImage.type,
            metric: 'image',
            axis: 1,
          },
        ],
        title: queryTitle,
      };
      updateOLArray(placeholdersObject);

      const saveResponse = (await API.graphql({
        query: storeQueriesV2,
        variables: {
          campaign_id: activeCampaign?.campaignId?.toString(),
          position:
            activeSubCampaign?.name && videoSource !== 'BVOD'
              ? `${props.componentID}_${activeSubCampaign.subcampaignId}`
              : props.componentID,
          query_id: queryId,
          title: queryTitle,
          metrics: {
            chartType: selectedImage.type,
            metric: 'image',
            axis: 1,
          },
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: StoreQueriesV2Mutation };

      console.log('Query saved successfully:', saveResponse);
    } catch (e) {
      console.error('Error saving query:', e);
      // alert('Greška prilikom spremanja. Molimo pokušajte ponovo.');
      throw e; // Re-throw to handle in calling function if needed
    }
  }

  useEffect(() => {
    const close = (e: any) => {
      if (e.key === 'Escape') {
        setShowModal(false);
      }
    };
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, []);

  // Helper function to clean filename by removing UUID prefix
  const cleanFileName = (fileName: string) => {
    if (!fileName) return '';
    // Split by underscore and take everything after the first underscore
    const underscoreIndex = fileName.indexOf('_');
    if (underscoreIndex > 0) {
      return fileName.substring(underscoreIndex + 1);
    }
    return fileName;
  };

  // Helper function to render file preview consistently
  const renderFilePreview = (file: any, size?: string, clickHandler?: () => void) => {
    if (!file) return null;

    // Check if it's a File object (new upload) or existing file object
    const isFileObject = file instanceof File;
    const fileUrl = isFileObject ? URL.createObjectURL(file) : file.url || file.webkitRelativePath || file.name;
    const fileName = file.name?.toLowerCase() || '';
    const cleanedFileName = cleanFileName(file.name || '');

    // Video files
    if (file.type.includes('video')) {
      const isModal = size === '1000px';
      return (
        <video
          className="imageThumbnail"
          controls
          style={
            isModal
              ? {
                  width: '100%',
                  height: 'auto',
                  maxWidth: '90vw',
                  maxHeight: '85vh',
                  backgroundColor: 'black',
                  borderRadius: '7px',
                }
              : {}
          }
          width={!isModal ? size || '250px' : undefined}
          src={fileUrl}
          onClick={clickHandler}
        />
      );
    }

    // Image files
    if (file.type.includes('image')) {
      const isModal = size === '1000px';
      return (
        <img
          className="imageThumbnail"
          alt="File preview"
          style={
            isModal
              ? {
                  width: '100%',
                  height: 'auto',
                  maxWidth: '90vw',
                  maxHeight: '85vh',
                  objectFit: 'contain',
                  backgroundColor: 'white',
                  borderRadius: '7px',
                }
              : {}
          }
          width={!isModal ? size || '250px' : undefined}
          src={fileUrl}
          onClick={clickHandler}
        />
      );
    }

    // PDF files
    if (fileName.endsWith('.pdf')) {
      const isModal = size === '1000px';
      const isEditModal = size === '400px';
      const isSmallEditModal = size === '250px';
      // Za glavni prikaz, uzmi punu dostupnu visinu
      const containerHeight = isModal ? '85vh' : isEditModal || isSmallEditModal ? '200px' : '100%';
      const containerWidth = isModal ? '87vw' : '100%';
      return (
        <div
          className="imageThumbnail"
          style={{
            height: containerHeight,
            width: containerWidth,
            minWidth: isModal ? containerWidth : 'auto',
            maxWidth: containerWidth,
            background: 'white',
            position: 'relative',
          }}
        >
          <iframe
            style={{
              width: '100%',
              height: isModal ? 'calc(100% - 10px)' : '100%',
              position: 'absolute',
              top: 0,
              left: 0,
              border: 'none',
            }}
            src={fileUrl}
            title="PDF preview"
          />
          {isModal && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                window.open(fileUrl, '_blank');
              }}
              style={{
                position: 'absolute',
                bottom: '10px',
                right: '15px',
                zIndex: 1000,
                padding: '8px',
                backgroundColor: '#007bff',
                border: 'none',
                borderRadius: '50%',
                color: 'white',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '36px',
                height: '36px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
              }}
              title="Open in Browser"
            >
              <IoMdOpen size={18} />
            </button>
          )}
          {clickHandler && (
            <div
              style={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 1,
                cursor: 'pointer',
              }}
              onClick={clickHandler}
            />
          )}
        </div>
      );
    }

    // Office and other document files
    const getDocumentIcon = (fileName: string) => {
      if (fileName.endsWith('.docx') || fileName.endsWith('.doc')) return 'description';
      if (fileName.endsWith('.pptx') || fileName.endsWith('.ppt')) return 'slideshow';
      if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls')) return 'table_chart';
      return 'insert_drive_file';
    };

    return (
      <div className="imageThumbnail">
        <div className="document-preview">
          <div className="document-icon">
            <span className="icon material-symbols-outlined">{getDocumentIcon(fileName)}</span>
          </div>
          <div className="document-info">
            <p>{cleanedFileName}</p>
            <p>{(file.size / 1024 / 1024).toFixed(2)} MB</p>
          </div>
          {size === '1000px' && (
            <a href={fileUrl} download={cleanedFileName} className="document-download-btn">
              Download
            </a>
          )}
        </div>
        {clickHandler && (
          <div
            style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}
            onClick={clickHandler}
          />
        )}
      </div>
    );
  };

  const handleUploadImageList = (isImage: boolean) => {
    if (props.setUploadComponents) {
      if (isImage) {
        const newUploadComponents = props.uploadComponents.map((elementArray: any[], index: number) => {
          return elementArray.map((element) => {
            if (!props.componentID.endsWith('.5')) {
              const findIndex = elementArray.findIndex((el) => el.id === props.componentID);
              if (findIndex !== -1 && elementArray[findIndex + 1]) {
                elementArray[findIndex + 1].visible = true;
              }
            } else {
              const nextElementArray = props.uploadComponents[index + 1];
              if (nextElementArray && nextElementArray[0]) {
                nextElementArray[0].visible = true;
              }
            }
            return element;
          });
        });
        props.setUploadComponents(newUploadComponents);
      } else {
        const newUploadComponents = props.uploadComponents.map((elementArray: any[], index: number) => {
          return elementArray.map((element) => {
            if (!props.componentID.endsWith('.5')) {
              const findIndex = elementArray.findIndex((el) => el.id === props.componentID);
              if (findIndex !== -1 && elementArray[findIndex + 1]) {
                elementArray[findIndex + 1].visible = false;
              }
            } else {
              const nextElementArray = props.uploadComponents[index + 1];
              if (nextElementArray && nextElementArray[0]) {
                nextElementArray[0].visible = false;
              }
            }
            return element;
          });
        });
        props.setUploadComponents(newUploadComponents);
      }
    }
  };
  return (
    <AudienceReportContainer
      style={{ display: visible ? 'block' : 'none' }}
      showModal={showModal}
      showUploadModal={showUploadModal}
    >
      {/* MAIN VIEW*/}
      <div className="wrapper">
        {!isImage && (
          <TxtContainer2 isGraph={true} displayTxt={0}>
            <Add isGraph={true}>
              <div className="text">
                <h1>File Upload</h1>
                {/* <h2>Press the button to begin</h2> */}
              </div>
              <button
                type="button"
                onClick={() => {
                  setUploadStat('home');
                  setShowUploadModal(true);
                }}
              >
                Add new
              </button>
            </Add>
          </TxtContainer2>
        )}

        {isImage && (
          <>
            {renderFilePreview(selectedImage, '250px')}
            <div className="edit-btns">
              <div
                className="edit-btn icon material-symbols-outlined"
                onClick={() => setShowModal(true)}
                title="Preview"
              >
                visibility
              </div>
              {statements?.Queries?.CREATE && (
                <div
                  className="edit-btn icon material-symbols-outlined"
                  onClick={(e) => {
                    e.stopPropagation();
                    setUploadStat('edit');
                    setShowUploadModal(true);
                  }}
                  title="Edit"
                >
                  edit
                </div>
              )}
            </div>
          </>
        )}
      </div>

      {/* MODAL FOR UPLOADING IMAGE*/}
      <div onClick={() => setShowUploadModal(false)} className="modalUpload myModal">
        {!selectedImage && uploadStat !== 'edit' ? (
          <HeadModul onClick={(e) => e.stopPropagation()} className="modalOverride">
            <button
              type="button"
              className="x"
              onClick={() => {
                if (uploadStat === 'home') {
                  setSelectedImage(null);
                  setIsImage(false);
                  handleUploadImageList(false);
                }
                setUploadStat(null);
                setShowUploadModal(false);
              }}
            >
              <IoMdClose className="closeIcon" />
            </button>
            <ModulContainer onClick={(e) => e.stopPropagation()} className="modal-content-upload">
              <FileUploader
                className="drop_area"
                handleChange={(file: any) => {
                  setSelectedImage(file);
                  setIsImage(true);
                  handleUploadImageList(true);
                }}
                name="file"
                types={fileTypes}
                children={dragAndDropContainer}
              />
            </ModulContainer>
          </HeadModul>
        ) : uploadStat === 'edit' ? (
          <HeadModul onClick={(e) => e.stopPropagation()} className="modalOverride">
            <button
              type="button"
              className="x"
              onClick={() => {
                setUploadStat(null);
                setShowUploadModal(false);
              }}
            >
              <IoMdClose className="closeIcon" />
            </button>
            <ModulContainer onClick={(e) => e.stopPropagation()} className="modalPreview">
              <div className="imageUploader">{renderFilePreview(selectedImage, '250px')}</div>
              <textarea
                className="inputField"
                onInput={(e) => setCaption((e.target as HTMLInputElement).value)}
                placeholder={caption ? caption : 'Add caption...'}
              ></textarea>
            </ModulContainer>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
              <button type="button" onClick={() => removeFromS3()}>
                Remove
              </button>
              <DarkButton
                type="button"
                onClick={async () => {
                  await putPresigned(true); // Proslijedi true za autoSave
                }}
              >
                Confirm
              </DarkButton>
            </div>
          </HeadModul>
        ) : (
          <HeadModul onClick={(e) => e.stopPropagation()} className="modalOverride">
            <ModulContainer onClick={(e) => e.stopPropagation()} className="modalPreview">
              <div className="imageUploader">{renderFilePreview(selectedImage, '400px')}</div>
              <textarea
                className="inputField"
                onInput={(e) => setCaption((e.target as HTMLInputElement).value)}
                placeholder={caption ? caption : 'Add caption...'}
              ></textarea>
            </ModulContainer>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
              <button type="button" onClick={() => removeFromS3()}>
                Remove
              </button>
              <DarkButton
                type="button"
                onClick={async () => {
                  await putPresigned(true); // Proslijedi true za autoSave
                }}
              >
                Confirm
              </DarkButton>
            </div>
          </HeadModul>
        )}
      </div>

      {/* MODAL FOR PREVIEWING IMAGE*/}
      <div onClick={() => setShowModal(false)} className="modal myModal">
        <span className="close" onClick={() => setShowModal(false)}>
          x
        </span>
        <div
          onClick={(e) => e.stopPropagation()}
          className="headModal"
          style={{
            boxShadow:
              selectedImage && selectedImage.file_name?.endsWith('.pdf')
                ? '0 0 0 2000px rgba(0, 0, 0, 0.8)'
                : '0 0 0 2000px rgba(0, 0, 0, 0.4)',
            backgroundColor: 'white',
            padding: '10px',
            borderRadius: '9px',
          }}
        >
          <div
            className="modal-content"
            style={{
              maxHeight: selectedImage && selectedImage.file_name?.endsWith('.pdf') ? '90vh' : '85vh',
              height: selectedImage && selectedImage.file_name?.endsWith('.pdf') ? '90vh' : 'auto',
              maxWidth: selectedImage && selectedImage.file_name?.endsWith('.pdf') ? '87vw' : '90vw',
              minWidth: selectedImage && selectedImage.file_name?.endsWith('.pdf') ? '87vw' : '400px',
              width: selectedImage && selectedImage.file_name?.endsWith('.pdf') ? '87vw' : 'auto',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'white',
              borderRadius: '7px',
            }}
          >
            {renderFilePreview(selectedImage, '1000px')}
          </div>
          <div className="caption">{caption}</div>
        </div>
      </div>
    </AudienceReportContainer>
  );
};

export const fileTypes = [
  'JPG',
  'PNG',
  'SVG',
  'PDF',
  'DOCX',
  'TXT',
  'ZIP',
  'MP4',
  'MOV',
  'AVI',
  'WMV',
  'FLV',
  'MPG',
  'MPEG',
  'M4V',
  'WEBM',
  'MKV',
  'OGG',
  'XLSX',
  'DOCX',
  'PPTX',
];

export const dragAndDropContainer = (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <div>
      <UploadIcon />
    </div>
    <h1 style={{ textAlign: 'center' }}>
      Drop your audio, video, MS office file <br />
      or
    </h1>
    <br />
    <button type="button">Choose file</button>
  </div>
);

export const smallDragAndDropContainer = (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      fontSize: '13px',
      padding: '1vw 1vw 1vw 1vw',
    }}
  >
    <h1 style={{ marginBottom: '1vw' }}>Drop files here or click to upload</h1>
    <button type="button">Choose file</button>
  </div>
);

export default ARContainer;
